import React, { useEffect, useRef } from "react";

import { generate } from "utils/array";

import styles from "./Clouds.module.css";

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
// It might be tempting to use Math.round() to accomplish that, but doing so
// would cause your random numbers to follow a non-uniform distribution, which
// may not be acceptable for your needs.
const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive
};

const getRandomItem = (list) => {
  return list[getRandomIntInclusive(1, list.length) - 1];
};

const boxShadows = (max) => {
  const boxShadowsCssArray = generate(max, () => {
    const offsetX = getRandomIntInclusive(1, 100);
    const offsetY = getRandomIntInclusive(1, 100);
    const blurRadius = getRandomIntInclusive(20, 40);
    const spreadRadius = getRandomIntInclusive(1, 20);
    const color = getRandomItem(["#f5f1d6", "#eae1b8"]);
    // `vmin` ==  min(viewportWidth, viewportHeight)
    return `${offsetX}vw ${offsetY}vh ${blurRadius}vmin ${spreadRadius}vmin ${color}`;
  });
  return boxShadowsCssArray.join(",");
};

const useClouds = (ref) => {
  useEffect(() => {
    let isMobile = window.matchMedia("only screen and (max-width: 760px)")
      .matches;

    if (!isMobile) {
      ref.current.style.boxShadow = boxShadows(100);
    }
  }, [ref]);
};

// https://codepen.io/yuanchuan/pen/f70a1f9435dc90197b253b26b4d69d42
const Clouds = () => {
  const ref = useRef();
  useClouds(ref);
  return (
    <>
      <div className={styles.clouds} ref={ref} />
      <svg className={styles.svg} width="0">
        <filter id="filter">
          <feTurbulence
            type="fractalNoise"
            baseFrequency=".01"
            numOctaves="10"
          />
          <feDisplacementMap in="SourceGraphic" scale="240" />
        </filter>
      </svg>
    </>
  );
};

export default Clouds;
